import React from 'react';
import PropTypes from 'prop-types';

export default function Info(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
  );
}

Info.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Info.defaultProps = {
  color: '#202020',
  width: 24,
};